import CmsPage from "./CmsPage";

const Festival = () => {
  return <CmsPage slug="festival" titleFallback="Festival" />;
};

export default Festival;
